import React, { Component } from "react";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { Button, ButtonGroup, Grid, Modal } from "semantic-ui-react";
import Immersive3dTourAppPageStore from "~/stores/Immersive3dTourAppPageStore";
import Immersive3dTourProjectSection from "./ReplacePanoramaPage/Immersive3dTourProjectSection";
import UploadReplacePanoramaSection from "./ReplacePanoramaPage/UploadReplacePanoramaSection";
import FlashMessage from "~/components/FlashMessage";
import UploadMultipleReplacePanoramaSection from "./ReplacePanoramaPage/UploadMultipleReplacePanoramaSection";

@observer
class ReplacePanoramaPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      confirmationModalVisible: false,
    };
  }

  showConfirmationModal = () => this.setState({ confirmationModalVisible: true });

  hideConfirmationModal = () => this.setState({ confirmationModalVisible: false });

  render() {
    const { immersive3dTourAppPageStore } = this.props;
    const { confirmationModalVisible } = this.state;

    const { immersive3dTourTabReplacePanoramaStore } = immersive3dTourAppPageStore;
    const {
      immersive3dTourProjectStore,
      replacePanoramaId,
      uploader,
      orderedReplacePanoramaData,
      flashMessageStore,
      immersive3dTourPanoramaZipDownloadStore,
      activeSection,
      uppyFileErrors,
      isUploading,
      isLoading,
      processingImageStore,
    } = immersive3dTourTabReplacePanoramaStore;
    const { immersive3dTourProject } = immersive3dTourProjectStore;

    let activeSectionContent = null;

    // eslint-disable-next-line default-case
    switch (activeSection) {
      case "immersive3dTourProject":
        activeSectionContent = (
          <Immersive3dTourProjectSection
            immersive3dTourProject={immersive3dTourProject}
            orderedReplacePanoramaData={orderedReplacePanoramaData}
            uppyFileErrors={uppyFileErrors}
            goToUploadReplacePanoramaSectionCallback={panoramaId =>
              immersive3dTourTabReplacePanoramaStore.goToUploadReplacePanoramaSection(panoramaId)
            }
            goToUploadMultipleReplacePanoramaSectionCallback={() =>
              immersive3dTourTabReplacePanoramaStore.goToUploadMultipleReplacePanoramaSection()
            }
            removeReplacePanoramaCallback={panoramaId =>
              immersive3dTourTabReplacePanoramaStore.removeItemsFromPropertyArrayByPanoramaId(
                "replacePanoramaData",
                panoramaId,
              )
            }
            getCachedImmersive3dTourOriginalImageCallback={panoramaId =>
              immersive3dTourTabReplacePanoramaStore.getCachedImmersive3dTourOriginalImage(panoramaId)
            }
            getImmersive3dTourOriginalImageSignedUrlCallback={panoramaId =>
              immersive3dTourTabReplacePanoramaStore.getImmersive3dTourOriginalImageSignedUrl(panoramaId)
            }
            getImmersive3dTourReplacePanoramaSignedUrlCallback={panoramaId =>
              immersive3dTourTabReplacePanoramaStore.getImmersive3dTourReplacePanoramaSignedUrl(panoramaId)
            }
            getImmersive3dTourCubeUrlCallback={panorama =>
              immersive3dTourTabReplacePanoramaStore.getImmersive3dTourCubeUrl(panorama)
            }
            getImmersive3dTourPanoramaZipDownloadUrlCallback={() =>
              immersive3dTourPanoramaZipDownloadStore.getUrlForGetOne()
            }
            openProcessingImageModalCallback={panoramaId =>
              immersive3dTourTabReplacePanoramaStore.openProcessingImageModal(panoramaId)
            }
            processingImageStore={processingImageStore}
          />
        );

        break;

      case "uploadReplacePanorama":
        activeSectionContent = (
          <UploadReplacePanoramaSection
            replacePanoramaId={replacePanoramaId}
            uploader={uploader}
            getCachedImmersive3dTourOriginalImageCallback={panoramaId =>
              immersive3dTourTabReplacePanoramaStore.getCachedImmersive3dTourOriginalImage(panoramaId)
            }
            goToImmersive3dTourProjectSectionCallback={() =>
              immersive3dTourTabReplacePanoramaStore.goToImmersive3dTourProjectSection()
            }
            flashMessageStore={flashMessageStore}
          />
        );

        break;

      case "uploadMultipleReplacePanorama":
        activeSectionContent = (
          <UploadMultipleReplacePanoramaSection
            uploader={uploader}
            goToImmersive3dTourProjectSectionCallback={() =>
              immersive3dTourTabReplacePanoramaStore.goToImmersive3dTourProjectSection()
            }
            flashMessageStore={flashMessageStore}
          />
        );

        break;
    }

    return (
      <>
        {activeSection === "immersive3dTourProject" && <FlashMessage flashMessageStore={flashMessageStore} />}
        <Grid>
          <Grid.Row>
            <Grid.Column width={8}>
              <h2 className="ui header">Replace panoramas</h2>
            </Grid.Column>
            <Grid.Column width={8} textAlign="right">
              <ButtonGroup>
                <Button
                  secondary
                  onClick={() => {
                    immersive3dTourAppPageStore.setIsReplacePanoramaPage(false);
                  }}
                >
                  Return
                </Button>
                <Button
                  primary
                  onClick={() => {
                    this.showConfirmationModal();
                  }}
                  disabled={isUploading || isLoading || orderedReplacePanoramaData.length === 0}
                >
                  Process
                </Button>
              </ButtonGroup>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <div className="ui dividing header" />
            </Grid.Column>
          </Grid.Row>
          {activeSectionContent}
        </Grid>
        <Modal open={confirmationModalVisible} onClose={() => this.hideConfirmationModal()}>
          <Modal.Header>Are you sure you want to replace these panoramas?</Modal.Header>
          <Modal.Content>
            <p>
              This will replace {orderedReplacePanoramaData.length} panoramas in your Immersive 3D Tour. The tour will
              be locked until the process is done. This usually takes a few minutes.
            </p>
          </Modal.Content>
          <Modal.Actions>
            <Button secondary onClick={() => this.hideConfirmationModal()}>
              Cancel
            </Button>
            <Button
              primary
              onClick={() => {
                immersive3dTourTabReplacePanoramaStore.process();
                this.hideConfirmationModal();
              }}
            >
              Ok
            </Button>
          </Modal.Actions>
        </Modal>
      </>
    );
  }
}

ReplacePanoramaPage.propTypes = {
  immersive3dTourAppPageStore: PropTypes.instanceOf(Immersive3dTourAppPageStore),
};

export default ReplacePanoramaPage;
